import React from 'react'
import Link from 'next/link'

import {t} from '@lib/helpers'

const ICONS = [
  <img
    key='0'
    src='/images/landing/Services_icon--light.svg'
    alt=''
    width='26'
    height='26'
  />,
  <img
    key='1'
    src='/images/landing/Services_icon--tag.svg'
    alt=''
    width='26'
    height='26'
  />,
  <img
    key='2'
    src='/images/landing/Services_icon--database.svg'
    alt=''
    width='26'
    height='26'
  />,
  <img
    key='3'
    src='/images/landing/Services_icon--rocket.svg'
    alt=''
    width='26'
    height='26'
  />,
  <img
    key='4'
    src='/images/landing/Services_icon--users.svg'
    alt=''
    width='26'
    height='26'
  />,
]

const Divider = () => (
  <div className='Landing__services__divider'>
    <span className='Landing__services__divider__line' />
    <span className='Landing__services__divider__dot' />
    <span className='Landing__services__divider__line Landing__services__divider__line--short' />
    <span className='Landing__services__divider__dot' />
    <span className='Landing__services__divider__line Landing__services__divider__line--short' />
    <span className='Landing__services__divider__dot' />
    <span className='Landing__services__divider__line' />
  </div>
)

const ServiceCard = ({title, description, icon, linkText}) => (
  <div className='Landing__services__card'>
    <div className='Landing__services__card__icon'>{icon}</div>
    <h3>{title}</h3>
    <p>{description}</p>
    <Link href='/services'>
      <a className='Landing__services__card__link'>
        {linkText}
        <span className='Landing__services__card__arrow'>
          <svg
            width='14'
            height='14'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path d='M5 12h14M12 5l7 7-7 7' />
          </svg>
        </span>
      </a>
    </Link>
  </div>
)

const Services = () => {
  const items = t('pages.index.landing.services.items') || []
  const linkText = t('pages.index.landing.services.link')

  const cards = Array.isArray(items)
    ? items.map((item, i) => ({
        ...item,
        icon: ICONS[i],
        linkText,
      }))
    : []

  return (
    <section className='Landing__services'>
      <div className='container'>
        <span className='Landing__services__label'>
          {t('pages.index.landing.services.label')}
        </span>
        <h2 className='Landing__services__h2'>
          {t('pages.index.landing.services.h2')}
        </h2>
        <p className='Landing__services__subtitle'>
          {t('pages.index.landing.services.subtitle')}
        </p>

        {/* Desktop layout: 3 + divider + 2 */}
        <div className='Landing__services__desktop'>
          <div className='Landing__services__grid-top'>
            {cards.slice(0, 3).map((card) => (
              <ServiceCard key={card.title} {...card} />
            ))}
          </div>
          <Divider />
          <div className='Landing__services__grid-bottom'>
            {cards.slice(3).map((card) => (
              <ServiceCard key={card.title} {...card} />
            ))}
          </div>
        </div>

        {/* Tablet layout: 2-2-1 with dividers */}
        <div className='Landing__services__tablet'>
          <div className='Landing__services__grid-2'>
            {cards.slice(0, 2).map((card) => (
              <ServiceCard key={card.title} {...card} />
            ))}
          </div>
          <Divider />
          <div className='Landing__services__grid-2'>
            {cards.slice(2, 4).map((card) => (
              <ServiceCard key={card.title} {...card} />
            ))}
          </div>
          <Divider />
          <div className='Landing__services__grid-1'>
            {cards[4] && <ServiceCard {...cards[4]} />}
          </div>
        </div>

        {/* Mobile layout: horizontal slide */}
        <div className='Landing__services__mobile'>
          {cards.map((card) => (
            <ServiceCard key={card.title} {...card} />
          ))}
        </div>
        <div className='Landing__services__mobile-line' />
      </div>
    </section>
  )
}

export default Services
